'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagKiAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 29 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M28.0001 0H5.60293e-05L0.00543394 19.9732H28.0054L28.0001 0Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M28.0001 0H5.60293e-05L0.00543394 10.6399H28.0054L28.0001 0Z",
          fill: "#E62B3F"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M14.0001 14.6667C15.841 14.6667 17.3334 13.1743 17.3334 11.3333C17.3334 9.49238 15.841 8 14.0001 8C12.1591 8 10.6667 9.49238 10.6667 11.3333C10.6667 13.1743 12.1591 14.6667 14.0001 14.6667Z",
          fill: "#FFDA57"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.0001 16.0469L12.3682 18.4828L11.9549 15.5801L9.4278 17.0667L10.3148 14.2722L7.39295 14.5151L9.40462 12.3822L6.66672 11.3333L9.40462 10.2844L7.39295 8.15149L10.3148 8.39442L9.4278 5.59988L11.9549 7.08649L12.3682 4.18384L14.0001 6.6197L15.6319 4.18384L16.0452 7.08649L18.5723 5.59988L17.6853 8.39442L20.6072 8.15149L18.5955 10.2844L21.3334 11.3333L18.5955 12.3822L20.6072 14.5151L17.6853 14.2722L18.5723 17.0667L16.0452 15.5801L15.6319 18.4828L14.0001 16.0469ZM14.0001 16C16.5774 16 18.6667 13.9106 18.6667 11.3333C18.6667 8.75598 16.5774 6.66664 14.0001 6.66664C11.4227 6.66664 9.33339 8.75598 9.33339 11.3333C9.33339 13.9106 11.4227 16 14.0001 16Z",
          fill: "#FFDA57"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.8134 3.20347L11.751 2.89178L13.0601 2.6736C13.0601 2.6736 11.3021 2.25813 10.7224 2.05022C9.88956 1.75147 10.0056 1.52035 10.0056 1.52035C10.0056 1.52035 12.3854 1.98788 13.5588 1.98788C13.8088 1.98788 14.3069 2.61126 14.3069 2.61126C14.3069 2.61126 15.1719 1.73732 15.5848 1.70736C17.4607 1.57126 19.4809 1.33333 19.4809 1.33333C19.4809 1.33333 18.8958 1.72565 18.5459 1.83204C17.5971 2.12046 15.5848 2.51775 15.5848 2.51775L15.3043 2.95412H17.2991L16.4575 3.20347L16.8939 3.60867C16.8939 3.60867 16.4361 3.37201 15.8342 3.48399C15.4207 3.56089 14.9381 3.83731 14.4939 3.95153C13.403 4.23205 12.7484 3.20347 12.7484 3.20347H11.8134Z",
          fill: "#FFDA57"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M28.0054 10.6399H0.00543394V19.9732H28.0054V10.6399Z",
          fill: "#0752A2"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M28.0055 16.2203L28.0001 17.6361L27.2992 17.3844C27.0939 17.316 26.6743 17.3166 26.4708 17.3844L23.7208 18.3011C23.2412 18.461 22.5257 18.46 22.0492 18.3011L19.2992 17.3844C19.0939 17.316 18.6743 17.3166 18.4708 17.3844L15.7208 18.3011C15.2412 18.461 14.5257 18.46 14.0492 18.3011L11.2992 17.3844C11.0939 17.316 10.6743 17.3166 10.4708 17.3844L7.72082 18.3011C7.24116 18.461 6.52574 18.46 6.04918 18.3011L3.29918 17.3844C3.09385 17.316 2.67433 17.3166 2.47082 17.3844L0.000867262 18.2526L0.000846752 16.7951L2.04918 16.1195C2.52575 15.9607 3.24116 15.9596 3.72081 16.1195L6.47081 17.0362C6.67433 17.104 7.09385 17.1046 7.29918 17.0362L10.0492 16.1195C10.5257 15.9607 11.2412 15.9596 11.7208 16.1195L14.4708 17.0362C14.6743 17.104 15.0939 17.1046 15.2992 17.0362L18.0492 16.1195C18.5257 15.9607 19.2412 15.9596 19.7208 16.1195L22.4708 17.0362C22.6743 17.104 23.0939 17.1046 23.2992 17.0362L26.0492 16.1195C26.5257 15.9607 27.2412 15.9596 27.7208 16.1195L28.0055 16.2203ZM28.0055 12.8954L28.0001 14.279L27.2992 14.0511C27.0939 13.9827 26.6743 13.9833 26.4708 14.0511L23.7208 14.9678C23.2412 15.1277 22.5257 15.1266 22.0492 14.9678L19.2992 14.0511C19.0939 13.9827 18.6743 13.9833 18.4708 14.0511L15.7208 14.9678C15.2412 15.1277 14.5257 15.1266 14.0492 14.9678L11.2992 14.0511C11.0939 13.9827 10.6743 13.9833 10.4708 14.0511L7.72082 14.9678C7.24116 15.1277 6.52574 15.1266 6.04918 14.9678L3.29918 14.0511C3.09385 13.9827 2.67433 13.9833 2.47082 14.0511L0.000856997 14.9402L-0.00576782 13.4562L2.04918 12.7862C2.52575 12.6273 3.24116 12.6263 3.72081 12.7862L6.47081 13.7029C6.67433 13.7707 7.09385 13.7713 7.29918 13.7029L10.0492 12.7862C10.5257 12.6273 11.2412 12.6263 11.7208 12.7862L14.4708 13.7029C14.6743 13.7707 15.0939 13.7713 15.2992 13.7029L18.0492 12.7862C18.5257 12.6273 19.2412 12.6263 19.7208 12.7862L22.4708 13.7029C22.6743 13.7707 23.0939 13.7713 23.2992 13.7029L26.0492 12.7862C26.5257 12.6273 27.2412 12.6263 27.7208 12.7862L28.0055 12.8954ZM28.0001 9.60262L28.0108 10.9487L27.2992 10.7178C27.0939 10.6493 26.6743 10.6499 26.4708 10.7178L23.7208 11.6344C23.2412 11.7943 22.5257 11.7933 22.0492 11.6344L19.2992 10.7178C19.0939 10.6493 18.6743 10.6499 18.4708 10.7178L15.7208 11.6344C15.2412 11.7943 14.5257 11.7933 14.0492 11.6344L11.2992 10.7178C11.0939 10.6493 10.6743 10.6499 10.4708 10.7178L7.72082 11.6344C7.24116 11.7943 6.52574 11.7933 6.04918 11.6344L3.29918 10.7178C3.09385 10.6493 2.67433 10.6499 2.47082 10.7178L-2.53906e-05 11.5L0.000856997 10.0974L2.04918 9.45286C2.52575 9.29401 3.24116 9.29298 3.72081 9.45286L6.47081 10.3695C6.67433 10.4374 7.09385 10.438 7.29918 10.3695L10.0492 9.45286C10.5257 9.29401 11.2412 9.29298 11.7208 9.45286L14.4708 10.3695C14.6743 10.4374 15.0939 10.438 15.2992 10.3695L18.0492 9.45286C18.5257 9.29401 19.2412 9.29298 19.7208 9.45286L22.4708 10.3695C22.6743 10.4374 23.0939 10.438 23.2992 10.3695L26.0492 9.45286C26.5257 9.29401 27.2412 9.29298 27.7208 9.45286L28.0001 9.60262Z",
          fill: "white"
        }
      )
    ]
  }
);
const VpFlagKiAsset = forwardRef(FlagKiAsset);

export { VpFlagKiAsset as default };
